import DiseaseEncyclopediaModel from '@/entities/disease-encyclopedia/model/diseaseEncyclopedia';
import ContentMarkDown from '@/shared/ui/content-mark-down/ContentMarkDown';
import { Swiper, SwiperSlide } from 'swiper/react';

interface Props {
  popularDiseaseEncyclopedia: DiseaseEncyclopediaModel[] | undefined;
  onClick: (disease: DiseaseEncyclopediaModel) => () => void;
}

const PopularDiseaseEncyclopediaSwiper = (props: Props) => {
  return (
    <Swiper slidesPerView={'auto'} spaceBetween={16} style={{ paddingLeft: 24, paddingRight: 24 }}>
      {props.popularDiseaseEncyclopedia?.map((disease) => (
        <SwiperSlide key={disease.getPublicId()} style={{ width: 'fit-content' }}>
          <button
            key={disease.getPublicId()}
            className='flex w-[230px] flex-col items-start gap-[12px] rounded-[8px]'
            onClick={props.onClick(disease)}
            type='button'
          >
            <div className='flex h-[152px] w-[230px] flex-shrink-0 items-center justify-center overflow-hidden rounded-[8px] bg-gray-30 pr-[38px] pl-[40px]'>
              {disease.getTitleImageUrl() && (
                <img
                  src={disease.getTitleImageUrl() ?? undefined}
                  alt={disease.getTitle()}
                  className='h-[152px] w-full object-cover'
                />
              )}
            </div>
            <div className='flex flex-col text-left'>
              <span className='typography-ui-17sb mb-1 line-clamp-1 overflow-ellipsis text-gray-900'>
                {disease.getTitle()}
              </span>
              <span className='typography-ui-15m line-clamp-2 h-[44px] overflow-ellipsis text-left text-gray-400'>
                <ContentMarkDown
                  markdown={disease.getContent() ?? ''}
                  components={{
                    h2: (_node, ..._rest) => {
                      return <></>;
                    },
                    h3: (_node, ..._rest) => {
                      return <></>;
                    },
                    h4: (_node, ..._rest) => {
                      return <></>;
                    },
                    p: (node, ...rest) => {
                      return <p {...rest}>{node.children}</p>;
                    },
                  }}
                />
              </span>
            </div>
          </button>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default PopularDiseaseEncyclopediaSwiper;
